export default __webpack_public_path__ + "static/upiOptions3-93f359d8080a02ddf585ded00373fb00.webm";